"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSelect = void 0;
const ButtonBehavior_1 = require("../ButtonBehavior");
const Products_text_update_1 = require("./Products_text_update");
const button_arrow_black_png_1 = __importDefault(require("../../img/button/button_arrow_black.png"));
const Products_Types_1 = require("./Products_Types");
// logo
const roadmap_1280_jpg_1 = __importDefault(require("../../img/purchase/roadmap_1280.jpg"));
const roadmap_1280_webp_1 = __importDefault(require("../../img/purchase/roadmap_1280.webp"));
const roadmap_fr_jpg_1 = __importDefault(require("../../img/purchase/roadmap_fr.jpg"));
const roadmap_fr_webp_1 = __importDefault(require("../../img/purchase/roadmap_fr.webp"));
const roadmap_it_jpg_1 = __importDefault(require("../../img/purchase/roadmap_it.jpg"));
const roadmap_it_webp_1 = __importDefault(require("../../img/purchase/roadmap_it.webp"));
const roadmap_de_jpg_1 = __importDefault(require("../../img/purchase/roadmap_de.jpg"));
const roadmap_de_webp_1 = __importDefault(require("../../img/purchase/roadmap_de.webp"));
const roadmap_es_jpg_1 = __importDefault(require("../../img/purchase/roadmap_es.jpg"));
const roadmap_es_webp_1 = __importDefault(require("../../img/purchase/roadmap_es.webp"));
const roadmap_nl_jpg_1 = __importDefault(require("../../img/purchase/roadmap_nl.jpg"));
const roadmap_nl_webp_1 = __importDefault(require("../../img/purchase/roadmap_nl.webp"));
const roadmap_pt_jpg_1 = __importDefault(require("../../img/purchase/roadmap_pt.jpg"));
const roadmap_pt_webp_1 = __importDefault(require("../../img/purchase/roadmap_pt.webp"));
const roadmap_uk_jpg_1 = __importDefault(require("../../img/purchase/roadmap_uk.jpg"));
const roadmap_uk_webp_1 = __importDefault(require("../../img/purchase/roadmap_uk.webp"));
const roadmap_au_jpg_1 = __importDefault(require("../../img/purchase/roadmap_au.jpg"));
const roadmap_au_webp_1 = __importDefault(require("../../img/purchase/roadmap_au.webp"));
const languageUtils_1 = require("../languageUtils");
const Products_1 = require("./Products");
const countriesList = Products_1.countryList;
const purchaseLinks = Products_1.purchaseLinks;
const editionsList = Products_1.editionsList;
const platformsList = Products_1.platformsList;
const comingSoonText = Products_1.comingSoon;
const editionsInfo = Products_1.editionsInfo;
class CustomSelect {
    constructor() {
        //setup/change glamshot and text based on edition chosen
        this.updateGlamAndText = () => {
            const lang = (0, languageUtils_1.getPurchaseLang)();
            const edition = (0, languageUtils_1.getEdition)();
            const platform = (0, languageUtils_1.getPlatform)();
            const isWebpAvailable = document.querySelector('html');
            const disclaimer = document.querySelector('.disclaimer');
            if (disclaimer) {
                disclaimer.classList.add('disclaimer--none');
                if (edition === 'digitalDeluxe' || edition === 'digitalSuper') {
                    if (platform === 'xbox' || platform === 'ps5') {
                        disclaimer.classList.remove('disclaimer--none');
                    }
                }
            }
            const glamshotImages = document.querySelectorAll('.purchase__glamshot img');
            const getImageSrc = (width, isWebp) => {
                const images = editionsInfo[lang][platform];
                const imagesForEdition = images[edition];
                if (width <= 640) {
                    return isWebp
                        ? imagesForEdition.image_640_webp
                        : imagesForEdition.image_640;
                }
                else {
                    return isWebp
                        ? imagesForEdition.image_1280_webp
                        : imagesForEdition.image_1280;
                }
            };
            glamshotImages.forEach(glamshot => {
                const isWebp = isWebpAvailable?.classList.contains('webp') ?? false;
                glamshot.src = getImageSrc(window.innerWidth, isWebp);
            });
            // Scroll to the top of the '.purchase' section
            // const purchaseSection = document.querySelector('.purchase');
            // if (purchaseSection) {
            //   purchaseSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // }
        };
        //create/update the purchase button
        this.purchaseBtns = () => {
            const lang = (0, languageUtils_1.getPurchaseLang)();
            const edition = (0, languageUtils_1.getEdition)();
            const platform = (0, languageUtils_1.getPlatform)();
            const retailer = this.selectedValueRetailers?.textContent || '';
            let purchaseHTMLDigital = '';
            let purchaseHTMLPhysical = '';
            console.log(edition);
            // Handling Digital Edition
            if ((0, Products_Types_1.isDigitalEdition)(edition) &&
                purchaseLinks[lang][platform]['digital'] &&
                purchaseLinks[lang][platform]['digital'][edition]) {
                console.log(edition);
                const digitalHREF = purchaseLinks[lang][platform]['digital'][edition].link;
                purchaseHTMLDigital = `
        <a 
          class="gtm__purchase" 
          href="${digitalHREF}" 
          target="_blank" 
          data-purchase="${lang} ${edition} ${platform}">
          <div class="btn">
            <div class="btn__background btn__background--right"></div>
            <img class="btn__arrow btn__arrow--right" src="${button_arrow_black_png_1.default}" alt="" />
            <h2>Available Now!</h2>
          </div>
        </a>
      `;
            }
            else {
                purchaseHTMLDigital = `
        <a 
          class="gtm__purchase" 
          target="_blank" 
          data-purchase="${lang} ${edition} ${platform}">
          <div class="btn">
            <div class="btn__background btn__background--grey btn__background--right"></div>
            <img class="btn__arrow btn__arrow--right" src="${button_arrow_black_png_1.default}" alt="" />
            <h2>Available Now!</h2>
          </div>
          <h5 class='custom__select__comingsoon__text btn__comingsoon'>${comingSoonText[lang]}</h5>
        </a>
      `;
            }
            if (this.platformButton) {
                this.platformButton.innerHTML = purchaseHTMLDigital;
            }
            if (platform !== 'steam' &&
                (edition === 'physicalLimited' || edition === 'physicalStandard') &&
                purchaseLinks[lang][platform]['physical'] &&
                purchaseLinks[lang][platform]['physical'][edition]) {
                const retailerList = purchaseLinks[lang][platform]['physical'][edition];
                if (retailerList && retailerList.length > 0) {
                    const index = retailerList.findIndex(obj => obj.name === retailer);
                    let physicalHREF = '';
                    if (index !== -1) {
                        physicalHREF = retailerList[index].link;
                        purchaseHTMLPhysical = `
            <a 
              class="gtm__purchase" 
              href="${physicalHREF}" 
              target="_blank" 
              data-purchase="${lang} ${edition} ${platform} ${retailer}">
              <div class="btn">
                <div class="btn__background btn__background--right"></div>
                <img class="btn__arrow btn__arrow--right" src="${button_arrow_black_png_1.default}" alt="" />
                <h2>Available Now!</h2>
              </div>
            </a>
          `;
                    }
                    else {
                        purchaseHTMLPhysical = `
            <a 
              class="gtm__purchase" 
              target="_blank" 
              data-purchase="${lang} ${edition} ${platform} ${retailer}">
              <div class="btn">
                <div class="btn__background btn__background--grey btn__background--right"></div>
                <img class="btn__arrow btn__arrow--right" src="${button_arrow_black_png_1.default}" alt="" />
                <h2>Available Now!</h2>
              </div>
              <h5 class='custom__select__comingsoon__text btn__comingsoon'>${Products_1.comingSoon[lang]}</h5>
            </a>
          `;
                    }
                }
                const retailerButton = document.querySelector('.custom__select__retailers__button');
                if (retailerButton) {
                    retailerButton.innerHTML = purchaseHTMLPhysical;
                }
            }
            //this switches the color arrow to red and back again on hover
            (0, ButtonBehavior_1.setupPurchaseButtonHover)();
            const products = Products_text_update_1.ProductsContent.getInstance();
            products.updatePurchaseBtnText();
        };
        //handles retailer list showing up and whether button next to platforms shows up if digital edition
        this.showHideBtns = (edition) => {
            const retailers = document.querySelector('.retailers');
            const platformButton = document.querySelector('.custom__select__platform__button');
            // Make sure the elements exist before accessing their classes
            if (retailers && platformButton) {
                if (edition.includes('digital')) {
                    retailers.classList.add('retailers__hidden');
                    platformButton.classList.remove('btn__hidden');
                }
                else {
                    retailers.classList.remove('retailers__hidden');
                    platformButton.classList.add('btn__hidden');
                }
            }
        };
        this.resetEdition = () => {
            const lang = (0, languageUtils_1.getPurchaseLang)();
            const platform = (0, languageUtils_1.getPlatform)();
            // Ensure the editions list is populated for the selected language
            if (!editionsList[lang] || editionsList[lang].length === 0) {
                console.error('No editions available for the selected language.');
                return;
            }
            // Reset Editions dropdown and select the first item
            const editionsDropdown = document.querySelector('.edition .custom__select__dropdown');
            if (editionsDropdown) {
                const secondEditionOption = editionsDropdown.querySelectorAll('li')[1];
                if (secondEditionOption) {
                    const secondEditionId = secondEditionOption.querySelector('input')?.id;
                    const secondEditionLabel = secondEditionOption.querySelector('label')?.textContent;
                    // Set the label to selected value
                    if (secondEditionLabel && this.selectedValueEdition) {
                        this.selectedValueEdition.textContent = secondEditionLabel;
                    }
                    // Set cookies for edition and update the UI
                    (0, languageUtils_1.setEdition)(secondEditionId);
                    secondEditionOption.querySelector('input')?.click(); // Simulate a click to select it
                    this.showHideBtns(secondEditionId || ''); // Update any UI elements based on the selected edition
                }
            }
        };
        //reset so when switching editions, goes back to first platform
        this.resetPlatform = () => {
            const lang = (0, languageUtils_1.getPurchaseLang)(); // Get language
            const editionType = (0, languageUtils_1.getEdition)(); // Get the current edition type (e.g., 'digitalStandard', 'physicalStandard')
            // Ensure lang is a valid language
            if (this.isValidPurchaseLanguage(lang)) {
                platformsList.forEach(platform => {
                    const platformLinks = purchaseLinks[lang]; // Get the platform links for the current language
                    // Check if `digital` is empty for digitalStandard edition
                    if (editionType.includes('digital')) {
                        const digital = platformLinks?.[platform.platform_id]['digital'];
                        // If `digital` is empty, hide the platform in the dropdown
                        if (digital && Object.keys(digital).length === 0) {
                            console.log(`Hiding platform with empty digital: ${platform.platform_id}`);
                            const platformElement = document.getElementById(platform.platform_id);
                            // Add hidden class to the platform item in the dropdown
                            if (platformElement) {
                                const listItem = platformElement.closest('li');
                                if (listItem) {
                                    listItem.classList.add('hidden'); // Hide the platform in the dropdown
                                }
                            }
                            return; // Skip the rest of the logic for this platform
                        }
                    }
                    // If `digital` is not empty (or not a digital edition), proceed with showing the platform
                    const platformElement = document.getElementById(platform.platform_id);
                    if (platformElement) {
                        const listItem = platformElement.closest('li');
                        const inputElement = platformElement.closest('input');
                        if (listItem && inputElement) {
                            inputElement.checked = false; // Reset checked state
                            // Show/hide platforms based on edition type (physical vs digital)
                            if ((editionType.includes('physical') && !platform.digitalOnly) ||
                                editionType.includes('digital')) {
                                if ((lang !== 'en' && !platform.retailUsaOnly) ||
                                    (lang !== 'ca' && !platform.retailUsaOnly) ||
                                    lang === 'en' ||
                                    lang === 'ca' ||
                                    editionType.includes('Standard') ||
                                    editionType.includes('Deluxe') ||
                                    editionType.includes('Super')) {
                                    listItem.classList.remove('hidden'); // Show platform
                                }
                                else {
                                    listItem.classList.add('hidden'); // Hide platform
                                }
                            }
                            else {
                                listItem.classList.add('hidden'); // Hide platform for non-matching edition
                            }
                        }
                    }
                });
            }
            // Set default platform (first platform in the list)
            const platformCookie = platformsList[0]?.platform_cookie;
            if (platformCookie) {
                (0, languageUtils_1.setPlatform)(platformCookie);
            }
            // Update selected platform text in the UI
            const selectedPlatformText = document.querySelector('.platform .custom__select .custom__select__dropdown li:nth-child(2) label')?.textContent;
            if (selectedPlatformText && this.selectedValuePlatform) {
                this.selectedValuePlatform.textContent = selectedPlatformText;
            }
            if (editionType.includes('digital')) {
                const platformDropdown = document.querySelector('.platform .custom__select__dropdown');
                // Select all li elements in the dropdown that do not have the "hidden" class
                const visibleOptions = platformDropdown?.querySelectorAll('li:not(.hidden) input');
                // Check if there are any visible options and click the second one
                if (visibleOptions && visibleOptions.length >= 2) {
                    const secondOption = visibleOptions[1]; // Get the second visible option
                    secondOption.click(); // Click the second visible option
                    // Get the label text for the clicked option (second visible option)
                    const selectedPlatformText = secondOption
                        .closest('li')
                        ?.querySelector('label')?.textContent;
                    // Update the text of the selected platform
                    if (selectedPlatformText && this.selectedValuePlatform) {
                        this.selectedValuePlatform.textContent = selectedPlatformText;
                    }
                }
            }
        };
        //hide current choices from dropDowns
        this.hideChoices = () => {
            const country = (0, languageUtils_1.getPurchaseLang)();
            const edition = (0, languageUtils_1.getEdition)();
            const platform = (0, languageUtils_1.getPlatform)();
            const retailerElement = document.querySelector('.retailers button .custom__select__value');
            if (!country || !edition || !platform || !retailerElement) {
                console.error('Missing required values for hiding choices.');
                return; // Exit early if essential data is missing
            }
            const retailer = retailerElement.textContent || '';
            const condensedName = retailer.toLowerCase().replace(' ', '_');
            const countryOption = document.querySelector(`.${country}`)?.closest('li');
            const editionOption = document.querySelector(`#${edition}`)?.closest('li');
            const platformOption = document
                .querySelector(`.${platform}`)
                ?.closest('li');
            const retailerOption = document
                .querySelector(`#${condensedName}`)
                ?.closest('li');
            // Reset all dropdown items to be visible first
            const dropdownList = document.querySelectorAll('.custom__select__dropdown li');
            dropdownList.forEach(item => {
                item.classList.remove('hidden--choice');
            });
            if (countryOption)
                countryOption.classList.add('hidden--choice');
            if (editionOption)
                editionOption.classList.add('hidden--choice');
            if (platformOption)
                platformOption.classList.add('hidden--choice');
            if (retailerOption)
                retailerOption.classList.add('hidden--choice');
        };
        //handles all select choices
        this.selectBtns = (eventTarget, btn) => {
            const btnCapitalize = btn.charAt(0).toUpperCase() + btn.slice(1).toLowerCase();
            const clickedItem = eval(`this.customSelect${btnCapitalize}`);
            const selectBtnToSet = eval(`this.selectBtn${btnCapitalize}`);
            if (eventTarget instanceof HTMLElement && eventTarget.closest('button')) {
                clickedItem?.classList.toggle('active');
                selectBtnToSet?.setAttribute('aria-expanded', `selectBtn${btnCapitalize}.getAttribute('aria-expanded')` === 'true'
                    ? 'false'
                    : 'true');
            }
            //using optional chaining here to make sure that if it's the button itself getting clicked an error doesn't get thrown.
            let eventName;
            const closestLi = eventTarget instanceof HTMLElement ? eventTarget.closest('li') : null;
            if (closestLi && closestLi.children[0] instanceof HTMLElement) {
                const child = closestLi.children[0];
                if (!child.classList.contains('select__option')) {
                    eventName = child.id;
                }
            }
            if (eventName) {
                // if (btn.toLowerCase() === 'country') {
                //   if (eventName !== 'select__option__country') {
                //     if (eventName === 'usa') {
                //       eventName = 'en';
                //     }
                //     setLanguage(eventName as LanguageKey);
                //     const url = new URL(location.href);
                //     url.searchParams.set('lang', eventName);
                //     history.pushState({}, '', url.toString());
                //     this.setUpRetailers();
                //     this.resetPlatform();
                //     this.newOptionsHandler();
                //     this.purchaseBtns();
                //     // hideChoices();
                //   }
                // }
                if (btn.toLowerCase() === 'country') {
                    if (eventName !== 'select__option__country') {
                        if (eventName === 'usa') {
                            eventName = 'en';
                        }
                        (0, languageUtils_1.setPurchaseLanguage)(eventName);
                        this.setUpRetailers();
                        this.resetPlatform();
                        this.newOptionsHandler();
                        this.purchaseBtns();
                        this.resetEdition();
                    }
                }
                if (btn.toLowerCase() === 'edition') {
                    (0, languageUtils_1.setEdition)(eventName);
                    this.showHideBtns(eventName);
                    this.resetPlatform();
                    this.setUpRetailers();
                    this.newOptionsHandler();
                    this.purchaseBtns();
                    this.updateGlamAndText();
                    // hideChoices();
                }
                if (btn.toLowerCase() === 'platform') {
                    (0, languageUtils_1.setPlatform)(eventName);
                    if (eventName !== 'select__option__platform') {
                        this.setUpRetailers();
                        this.newOptionsHandler();
                        this.purchaseBtns();
                        this.updateGlamAndText();
                        // hideChoices();
                    }
                }
                if (btn.toLowerCase() === 'retailers') {
                    this.purchaseBtns();
                    // hideChoices();
                }
            }
        };
        //creates the editions menu
        this.setUpEditions = () => {
            const lang = (0, languageUtils_1.getPurchaseLang)();
            if (!lang) {
                console.error('Language not found in cookies.');
                return;
            }
            let editionsHTML = `
        <li role="option"  class="select__option">
          <input type="radio" id="select__option__edition" class="select__option" name="edition" disabled />
          <label for="select__option__edition" >Select an Option</label>
        </li>
    `;
            if (editionsList[lang].length !== 0) {
                editionsList[lang].forEach(edition => {
                    editionsHTML += `
        <li role="option">
            <input type="radio" id="${edition.edition_id}" name="edition" />
            <label for="${edition.edition_id}">${edition.edition_name}</label>
        </li>
        `;
                });
                const dropdown = document.querySelector('.edition .custom__select__dropdown');
                if (dropdown) {
                    dropdown.innerHTML = editionsHTML;
                }
                else {
                    console.log('dropdown element not found');
                }
                const editionType = editionsList[lang][0].edition_id;
                (0, languageUtils_1.setEdition)(editionType);
                this.showHideBtns(editionType);
                let selectedElement = document.querySelector('.edition .custom__select .custom__select__dropdown li:nth-child(2) label');
                if (selectedElement && this.selectedValueEdition) {
                    this.selectedValueEdition.textContent = selectedElement.textContent;
                }
            }
        };
        // creates the countries menu
        this.setUpCountries = () => {
            let countriesHTML = `
      <li role="option"  class="select__option">
        <input type="radio" id="select__option__country" name="country" disabled />
        <label for="select__option__country">Select an Option</label>
      </li>
    `;
            if (countriesList.length !== 0) {
                countriesList.forEach(country => {
                    countriesHTML += `
          <li role="option">
              <input type="radio" id="${country.country_id}" name="country" class="${country.country_cookie}" />
              <label for="${country.country_id}">${country.country_name}</label>
          </li>
          `;
                });
                const countryDropdown = document.querySelector('.country .custom__select__dropdown');
                if (countryDropdown) {
                    countryDropdown.innerHTML = countriesHTML;
                }
            }
            let lang = (0, languageUtils_1.getPurchaseLang)();
            // selectedValueCountry.textContent = document.querySelector(
            //   '.country .custom__select .custom__select__dropdown li label',
            // ).textContent;
            if (lang) {
                const countryElement = document.querySelector(`.${lang}`);
                if (countryElement &&
                    countryElement.nextElementSibling &&
                    this.selectedValueCountry) {
                    this.selectedValueCountry.textContent =
                        countryElement.nextElementSibling.textContent;
                }
                else {
                    console.error('Selected country label not found or empty.');
                }
            }
            else {
                console.error('Language cookie not found.');
            }
        };
        //creates the platforms menu
        this.setUpPlatforms = () => {
            const lang = (0, languageUtils_1.getPurchaseLang)();
            let platformsHTML = `
    <li role="option"  class="select__option">
      <input type="radio" id="select__option__platform" name="platform" disabled />
      <label for="select__option__platform">Select an Option</label>
    </li>
    `;
            if (platformsList.length !== 0) {
                platformsList.forEach(platform => {
                    platformsHTML += `
          <li role="option" class="hidden">
              <input type="radio" id="${platform.platform_id}" name="platform" class="${platform.platform_cookie}" />
              <label for="${platform.platform_id}">${platform.platform_name}</label>
          </li>
          `;
                });
                const platformDropdown = document.querySelector('.platform .custom__select__dropdown');
                if (platformDropdown) {
                    platformDropdown.innerHTML = platformsHTML;
                    this.resetPlatform();
                }
                else {
                    console.error('Platform dropdown element not found.');
                }
            }
            else {
                console.log('No platforms available.');
            }
        };
        //creates list of retailers
        this.setUpRetailers = () => {
            const lang = (0, languageUtils_1.getPurchaseLang)();
            const langTextOnly = (0, languageUtils_1.getLanguage)();
            let platform = (0, languageUtils_1.getPlatform)();
            const edition = (0, languageUtils_1.getEdition)();
            if (!edition.includes('digital')) {
                let retailersHTML = `
        <li role="option"  class="select__option">
          <input type="radio" id="select__option__retailer" name="retailers" disabled />
          <label for="select__option__retailer" >Select an Option</label>
        </li>
      `;
                if (platform !== 'steam' &&
                    (edition === 'physicalLimited' || edition === 'physicalStandard') &&
                    purchaseLinks[lang][platform]['physical'] &&
                    purchaseLinks[lang][platform]['physical'][edition]) {
                    const retailerList = purchaseLinks[lang][platform]['physical'][edition] || [];
                    //NOTE: need to add the else statment here to deal  with coming soon if retailer links aren't available
                    if (retailerList.length !== 0) {
                        retailerList.forEach(retailer => {
                            if (retailer.name) {
                                const condensedName = retailer.name
                                    .toLowerCase()
                                    .replace(' ', '_');
                                retailersHTML += `
              <li role="option">
                <input type="radio" id="${condensedName}" name="retailers" />
                <label for="${condensedName}">${retailer.name}</label>
              </li>
              `;
                            }
                        });
                    }
                    else {
                        retailersHTML = '';
                        if (this.selectedValueRetailers) {
                            this.selectedValueRetailers.textContent = `${comingSoonText[langTextOnly]}`;
                        }
                    }
                }
                const retailerDropdown = document.querySelector('.retailers .custom__select__dropdown');
                if (retailerDropdown) {
                    retailerDropdown.innerHTML = retailersHTML;
                }
                else {
                    console.error('Retailers dropdown element not found.');
                }
                const selectedRetailerLabel = document.querySelector('.retailers .custom__select .custom__select__dropdown li:nth-child(2) label');
                if (selectedRetailerLabel && this.selectedValueRetailers) {
                    this.selectedValueRetailers.textContent =
                        selectedRetailerLabel.textContent;
                }
            }
        };
        this.updateDemoLinks = () => {
            const canadaLinks = document.querySelector('.purchase__demo__logos--CA');
            const auLinks = document.querySelector('.purchase__demo__logos--AU');
            const demoCountryNameFirst = document.querySelector('.demoCountryNameFirst');
            const demoCountryNameSecond = document.querySelector('.demoCountryNameSecond');
            const demoLine = document.querySelector('.purchase__demo__line');
            const lang = (0, languageUtils_1.getLanguage)();
            if (!Products_1.demoLinks[lang])
                return;
            if (lang !== 'en' && lang !== 'au') {
                canadaLinks?.classList.add('purchase__demo__hidden');
                auLinks?.classList.add('purchase__demo__hidden');
                demoCountryNameFirst?.classList.add('purchase__demo__hidden');
                demoCountryNameSecond?.classList.add('purchase__demo__hidden');
                demoLine?.classList.add('purchase__demo__hidden');
            }
            else if (lang === 'en') {
                canadaLinks?.classList.remove('purchase__demo__hidden');
                auLinks?.classList.add('purchase__demo__hidden');
                if (demoCountryNameFirst)
                    demoCountryNameFirst.textContent = 'United States';
                if (demoCountryNameSecond)
                    demoCountryNameSecond.textContent = 'Canada';
                demoLine?.classList.remove('purchase__demo__hidden');
            }
            else if (lang === 'au') {
                canadaLinks?.classList.add('purchase__demo__hidden');
                auLinks?.classList.remove('purchase__demo__hidden');
                if (demoCountryNameFirst)
                    demoCountryNameFirst.textContent = 'Australia';
                if (demoCountryNameSecond)
                    demoCountryNameSecond.textContent = 'New Zealand';
                demoLine?.classList.remove('purchase__demo__hidden');
            }
            const switchLink = document.querySelector('.demoBtnSwitch');
            const ps5Link = document.querySelector('.demoBtnPS5');
            const xboxLink = document.querySelector('.demoBtnXbox');
            const steamLink = document.querySelector('.demoBtnSteam');
            // const hideSwitchLangs = ['UK', 'IT', 'DE', 'ES', 'FR', 'NL', 'PT'];
            // if (switchLink) {
            //   if (hideSwitchLangs.includes(lang.toUpperCase())) {
            //     switchLink.style.display = 'none';
            //   } else {
            //     switchLink.style.display = ''; // show it if not hidden
            //     switchLink.href = demoLinks[lang].switch;
            //   }
            // }
            if (switchLink)
                switchLink.href = Products_1.demoLinks[lang].switch;
            if (ps5Link)
                ps5Link.href = Products_1.demoLinks[lang].ps5;
            if (xboxLink)
                xboxLink.href = Products_1.demoLinks[lang].xbox;
            if (steamLink)
                steamLink.href = Products_1.demoLinks[lang].steam;
        };
        this.updateDLCLinks = () => {
            const switchLink = document.querySelector('.dlc__switch');
            const ps5Link = document.querySelector('.dlc__ps5');
            const xboxLink = document.querySelector('.dlc__xbox');
            const steamLink = document.querySelector('.dlc__steam');
            const dlcMain = document.querySelector('.dlc__buttons');
            const dlcMainNA = document.querySelector('.dlc__buttons__NA');
            const dlcMainAU = document.querySelector('.dlc__buttons__AU');
            const lang = (0, languageUtils_1.getLanguage)();
            if (lang === 'en' || lang === 'ca') {
                dlcMain?.classList.add('purchase__demo__hidden');
                dlcMainAU?.classList.add('purchase__demo__hidden');
                dlcMainNA?.classList.remove('purchase__demo__hidden');
            }
            else if (lang === 'au' || lang === 'nz') {
                dlcMain?.classList.add('purchase__demo__hidden');
                dlcMainAU?.classList.remove('purchase__demo__hidden');
                dlcMainNA?.classList.add('purchase__demo__hidden');
            }
            else {
                dlcMain?.classList.remove('purchase__demo__hidden');
                dlcMainAU?.classList.add('purchase__demo__hidden');
                dlcMainNA?.classList.add('purchase__demo__hidden');
            }
            if (!Products_1.DLCLinks[lang])
                return;
            if (switchLink)
                switchLink.href = Products_1.DLCLinks[lang].switch;
            if (ps5Link)
                ps5Link.href = Products_1.DLCLinks[lang].ps5;
            if (xboxLink)
                xboxLink.href = Products_1.DLCLinks[lang].xbox;
            if (steamLink)
                steamLink.href = Products_1.DLCLinks[lang].steam;
        };
        this.updateRoadmap = () => {
            const roadmapImages = {
                en: roadmap_1280_jpg_1.default,
                fr: roadmap_fr_jpg_1.default,
                it: roadmap_it_jpg_1.default,
                de: roadmap_de_jpg_1.default,
                es: roadmap_es_jpg_1.default,
                nl: roadmap_nl_jpg_1.default,
                pt: roadmap_pt_jpg_1.default,
                uk: roadmap_uk_jpg_1.default,
                au: roadmap_au_jpg_1.default,
            };
            const roadmapImagesWebp = {
                en: roadmap_1280_webp_1.default,
                fr: roadmap_fr_webp_1.default,
                it: roadmap_it_webp_1.default,
                de: roadmap_de_webp_1.default,
                es: roadmap_es_webp_1.default,
                nl: roadmap_nl_webp_1.default,
                pt: roadmap_pt_webp_1.default,
                uk: roadmap_uk_webp_1.default,
                au: roadmap_au_webp_1.default,
            };
            const roadmap = document.querySelector('.roadmapImg');
            if (!roadmap)
                return;
            // Normalize language → 'en' if unknown/alias
            let lang = (0, languageUtils_1.getLanguage)();
            // if (['en', 'uk', 'au'].includes(lang)) lang = 'en';
            // Use fallback 'en' if no match found
            const fallback = 'en';
            const jpg = roadmapImages[lang] ?? roadmapImages[fallback];
            const webp = roadmapImagesWebp[lang] ?? roadmapImagesWebp[fallback];
            // Detect WebP support by <html class="webp">
            const isWebp = document.documentElement.classList.contains('webp');
            roadmap.src = isWebp ? webp : jpg;
        };
        this.customSelectEdition = document.querySelector('.edition .custom__select');
        this.selectBtnEdition = document.querySelector('.edition .custom__select__button');
        this.selectedValueEdition = document.querySelector('.edition .custom__select__value');
        this.optionsListEdition = document.querySelectorAll('.edition .custom__select__dropdown li');
        this.customSelectCountry = document.querySelector('.country .custom__select');
        this.selectBtnCountry = document.querySelector('.country .custom__select__button');
        this.selectedValueCountry = document.querySelector('.country .custom__select__value');
        this.optionsListCountry = document.querySelectorAll('.country .custom__select__dropdown li');
        this.customSelectPlatform = document.querySelector('.platform .custom__select');
        this.selectBtnPlatform = document.querySelector('.platform .custom__select__button');
        this.selectedValuePlatform = document.querySelector('.platform .custom__select__value');
        this.optionsListPlatform = document.querySelectorAll('.platform .custom__select__dropdown li');
        this.customSelectRetailers = document.querySelector('.retailers .custom__select');
        this.selectBtnRetailers = document.querySelector('.retailers .custom__select__button');
        this.selectedValueRetailers = document.querySelector('.retailers .custom__select__value');
        this.optionsListRetailers = document.querySelectorAll('.retailers .custom__select__dropdown li');
        this.platformButton = document.querySelector('.custom__select__platform__button');
        // Binding 'this' for the event listener
        this.updateGlamAndText = this.updateGlamAndText.bind(this);
        // Setting up resize event listener
        window.addEventListener('resize', this.updateGlamAndText);
        this.init();
    }
    init() {
        this.setUpEditions();
        this.setUpCountries();
        this.setUpPlatforms();
        this.setUpRetailers();
        this.purchaseBtns();
        this.handlerSetup();
        this.updateGlamAndText();
        this.updateDemoLinks();
        this.updateDLCLinks();
        this.updateRoadmap();
        this.scrollToDemoIfHash();
        // this.hideChoices();
    }
    // this controls where the demo button will scroll too
    scrollToDemoIfHash() {
        window.addEventListener('load', () => {
            const hash = window.location.hash;
            if (hash === '#demo') {
                const target = document.getElementById('demo');
                if (target) {
                    const offset = 80; // px above
                    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
                    console.log(targetPosition);
                    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                }
            }
        });
    }
    isValidPurchaseLanguage(lang) {
        return [
            'en',
            'ca',
            'au',
            'nz',
            'uk',
            'fr',
            'de',
            'es',
            'it',
            'pt',
            'nl',
            'ch',
            'be',
            'pl',
            'se',
            'no',
            'dk',
        ].includes(lang);
    }
    closeAllSelect(evt) {
        const customSelectMenu = document.querySelectorAll('.custom__select');
        // Ensure evt.target is treated as a valid DOM element
        const target = evt.target;
        customSelectMenu.forEach(menu => {
            if (menu !== target && !menu.contains(target)) {
                menu.classList.remove('active');
            }
        });
    }
    newOptionsHandler() {
        const checkOption = document.querySelectorAll('.retailers .custom__select__dropdown li');
        checkOption.forEach(option => {
            const clickHandler = (e) => {
                let fromOptionList = e.target.closest('aside')
                    ?.classList[0];
                if (!fromOptionList)
                    return;
                fromOptionList =
                    fromOptionList.charAt(0).toUpperCase() + fromOptionList.slice(1);
                const selectedValue = eval(`this.selectedValue${fromOptionList}`);
                const customSelect = eval(`this.customSelect${fromOptionList}`);
                if (!selectedValue || !customSelect)
                    return;
                if (e.clientX !== 0 && e.clientY !== 0) {
                    selectedValue.textContent = option.children[1].textContent;
                    customSelect.classList.remove('active');
                }
            };
            const keyupHandler = (e) => {
                let fromOptionList = e.target.closest('aside')
                    ?.classList[0];
                if (!fromOptionList)
                    return;
                fromOptionList =
                    fromOptionList.charAt(0).toUpperCase() + fromOptionList.slice(1);
                const selectedValue = eval(`this.selectedValue${fromOptionList}`);
                const customSelect = eval(`this.customSelect${fromOptionList}`);
                if (!selectedValue || !customSelect)
                    return;
                if (e.key === 'Enter') {
                    selectedValue.textContent = option.textContent;
                    customSelect.classList.remove('active');
                }
            };
            option.addEventListener('keyup', keyupHandler);
            option.addEventListener('click', clickHandler);
        });
    }
    //sets up handlers, so deals with what happens when the button is clicked, or an option from the menu is chosen
    handlerSetup() {
        const checkTarget = document.querySelectorAll('.edition .custom__select,.country .custom__select, .platform .custom__select, .retailers .custom__select');
        const checkOption = document.querySelectorAll('.edition .custom__select__dropdown li,.country .custom__select__dropdown li, .platform .custom__select__dropdown li, .retailers .custom__select__dropdown li');
        let selectOptions = Array.from(document.querySelectorAll('.select__option'));
        checkTarget.forEach(item => {
            const element = item;
            const handler = (e) => {
                const target = e.target;
                if (target) {
                    this.selectBtns(target, target.closest('aside')?.classList[0] || '');
                }
            };
            element.addEventListener('click', handler);
        });
        checkOption.forEach(option => {
            const handler = (e) => {
                const target = e.target;
                if (target && !selectOptions.includes(option)) {
                    let fromOptionList = target.closest('aside')?.classList[0];
                    if (fromOptionList) {
                        fromOptionList =
                            fromOptionList.charAt(0).toUpperCase() + fromOptionList.slice(1);
                    }
                    const selectedValue = eval(`this.selectedValue${fromOptionList}`);
                    const customSelect = eval(`this.customSelect${fromOptionList}`);
                    if (!selectedValue || !customSelect)
                        return;
                    // Click Events
                    if (e instanceof MouseEvent &&
                        e.type === 'click' &&
                        e.clientX !== 0 &&
                        e.clientY !== 0) {
                        selectedValue.textContent = option.children[1]?.textContent;
                        customSelect.classList.remove('active');
                    }
                    // Key Events
                    if (e instanceof KeyboardEvent &&
                        e.type === 'keyup' &&
                        e.key === 'Enter') {
                        selectedValue.textContent = option.textContent;
                        customSelect.classList.remove('active');
                    }
                }
            };
            option.addEventListener('keyup', handler);
            option.addEventListener('click', handler);
        });
        /* if the user clicks anywhere outside the select box,
            then close all select boxes: */
        document.addEventListener('click', this.closeAllSelect);
    }
}
exports.CustomSelect = CustomSelect;
